/* BH custom click collector v1.1.5 candidate. Only emitBhClick owns delivery and consent. */
(function (window, document) {
  'use strict';
  var VERSION = '1.1.5-candidate';
  if (window.BHClickTracker && window.BHClickTracker.version === VERSION) {
    window.BHClickTracker.init();
    return;
  }
  if (window.BHClickTracker && typeof window.BHClickTracker.destroy === 'function') window.BHClickTracker.destroy();

  var active = false;
  var config;
  var seen = new WeakSet();
  var state = freshState();
  var kinds = {
    home_banner: ['image', 'cta'],
    announcement: ['cta'],
    menu: ['menu_item'],
    collection_promo: ['image', 'cta'],
    load_more: ['button'],
    description: ['accordion_header']
  };

  function freshState() {
    return { matched: 0, submitted: 0, rejected: 0, errors: 0, last: [], handlerSamplesMs: [] };
  }

  function identifier(value) {
    return typeof value === 'string' && /^[A-Za-z0-9][A-Za-z0-9_.:-]{0,99}$/.test(value)
      && !/^\+?\d{7,}$/.test(value) ? value : null;
  }

  function positiveInteger(value) {
    if (!/^\d{1,5}$/.test(String(value))) return null;
    var number = Number(value);
    return number > 0 && number <= 10000 ? number : null;
  }

  function configuredLabel(contentId) {
    var labels = config && config.contentLabels;
    if (!labels || typeof labels !== 'object' || Array.isArray(labels)) return null;
    var descriptor = Object.getOwnPropertyDescriptor(labels, contentId);
    if (!descriptor || !Object.prototype.hasOwnProperty.call(descriptor, 'value')) return null;
    var value = descriptor.value;
    if (typeof value !== 'string' || value.length < 1 || value.length > 100 || value.trim() !== value ||
        /[\u0000-\u001f\u007f<>]/.test(value) || /[\w.+\-]+@[\w.\-]+\.[a-z]{2,}/i.test(value) ||
        /(?:^|[^a-z\d])\+?\d[\d\s().\-]{5,}\d(?:$|[^a-z\d])/i.test(value) ||
        /(?:email|e-mail|phone|telephone|mobile|customer_id|token|password)\s*=/i.test(value)) return null;
    return value;
  }

  function pageType(value) {
    if (value === 'index') return 'home';
    return ['home', 'collection', 'product', 'page'].indexOf(value) !== -1 ? value : null;
  }

  // Values inherit only from a matching marked context. A different region is a boundary.
  function attribute(target, area, name) {
    var node = target;
    var attr = 'data-bh-' + name;
    while (node && node.nodeType === 1) {
      var nodeArea = node.getAttribute('data-bh-area');
      if (nodeArea && nodeArea !== area) break;
      if (node === target || nodeArea === area) {
        var value = node.getAttribute(attr);
        if (value !== null) return value;
      }
      node = node.parentElement;
    }
    return null;
  }

  function currentPath() {
    return window.location.pathname.replace(/\/$/, '') || '/';
  }

  function inScope(area, type) {
    var scope = config.scopes && config.scopes[area];
    if (!scope || !Array.isArray(scope.pageTypes) || scope.pageTypes.indexOf(type) === -1) return false;
    if (!scope.paths) return true;
    return Array.isArray(scope.paths) && scope.paths.indexOf(currentPath()) !== -1;
  }

  function hrefForAction(target) {
    var raw = target.getAttribute('href');
    if (!raw || /^\s*(#|javascript:|mailto:|tel:|data:)/i.test(raw)) return null;
    try {
      var url = new URL(raw, window.location.href);
      return /^(https?:)$/.test(url.protocol) ? url : null;
    } catch (ignore) {
      return null;
    }
  }

  // Only a public storefront route is sent. Never mutate the visitor's real URL.
  function safeTargetPath(url, note) {
    function omit(reason) { note.reason = reason; return null; }
    var hosts = Array.isArray(config.allowedHosts) ? config.allowedHosts : [window.location.hostname];
    if (hosts.indexOf(url.hostname.toLowerCase()) === -1 || url.username || url.password) return omit('not_public_same_site');
    var path = url.pathname.replace(/\/{2,}/g, '/').replace(/\/$/, '') || '/';
    if (path.length > 100) return omit('path_over_100_characters');
    var decoded;
    try { decoded = decodeURIComponent(path); } catch (ignore) { return omit('invalid_path_encoding'); }
    if (/[\u0000-\u0020@\\]/.test(decoded) || /\/(account|customers?|checkout|orders?|reset|tokens?)(\/|$)/i.test(decoded)) return omit('private_path');
    // A phone number embedded in a public path is not a valid content handle for this project.
    if (/(^|\/)[+]?\d[\d(). -]{6,}(\/|$)/.test(decoded)) return omit('private_path');
    if (decoded !== '/' && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections|products|pages|blogs)\/[A-Za-z0-9_%./-]+$/i.test(decoded)) return omit('not_public_content_route');
    return path;
  }

  function disabled(target) {
    var node = target;
    while (node && node.nodeType === 1) {
      if (node.hasAttribute('disabled') || node.getAttribute('aria-disabled') === 'true'
          || node.hasAttribute('inert') || node.hasAttribute('hidden')) return true;
      node = node.parentElement;
    }
    return false;
  }

  function diagnosticsEnabled() {
    var debug = config && config.diagnostics;
    var theme = window.Shopify && window.Shopify.theme;
    return !!(debug && debug.enabled === true && debug.draftThemeId && theme
      && String(debug.draftThemeId) === String(theme.id) && theme.role && theme.role !== 'main');
  }

  function renderDiagnostics() {
    if (!diagnosticsEnabled()) return;
    var el = document.getElementById('bh-tracking-diagnostics');
    if (!el) {
      el = document.createElement('script');
      el.id = 'bh-tracking-diagnostics';
      el.type = 'application/json';
      (document.head || document.documentElement).appendChild(el);
    }
    el.textContent = JSON.stringify({ version: VERSION, themeId: String(window.Shopify.theme.id), collector: state });
  }

  function record(status, reason, payload, omittedUrlReason) {
    if (status === 'submitted') state.submitted += 1;
    else if (status === 'error') state.errors += 1;
    else state.rejected += 1;
    if (diagnosticsEnabled()) {
      // Payload has passed the whitelist; raw href, text and visitor identifiers are never recorded.
      var item = { status: status, reason: reason };
      if (payload) item.params = payload;
      if (omittedUrlReason) item.targetUrlOmitted = omittedUrlReason;
      state.last.push(item);
      if (state.last.length > 20) state.last.shift();
      renderDiagnostics();
    }
  }

  function makePayload(target, area, entry, type) {
    var content = attribute(target, area, 'content-id');
    if (!content && (area === 'load_more' || area === 'description')) content = area;
    var payload = {
      bh_area: area,
      entry_type: entry,
      content_id: identifier(content),
      block_key: identifier(attribute(target, area, 'block-key')),
      page_type: type
    };
    if (!payload.content_id || !payload.block_key) return null;
    payload.content_label = configuredLabel(payload.content_id);
    if (!payload.content_label) return null;

    if (area === 'home_banner') {
      payload.banner_index = positiveInteger(attribute(target, area, 'banner-index'));
      if (!payload.banner_index) return null;
    } else if (area === 'announcement') {
      payload.position = positiveInteger(attribute(target, area, 'position'));
      if (!payload.position) return null;
    } else if (area === 'menu') {
      payload.menu_type = attribute(target, area, 'menu-type');
      payload.menu_item_id = identifier(attribute(target, area, 'menu-item-id'));
      payload.position = positiveInteger(attribute(target, area, 'position'));
      if (['product_category', 'collection_series'].indexOf(payload.menu_type) === -1
          || !payload.menu_item_id || !payload.position) return null;
    } else if (area === 'collection_promo' || area === 'load_more') {
      payload.collection_handle = identifier(attribute(target, area, 'collection-handle') || config.collectionHandle);
      if (!payload.collection_handle) return null;
      if (area === 'collection_promo') {
        payload.position = positiveInteger(attribute(target, area, 'position'));
        if (!payload.position) return null;
      }
    } else if (area === 'description') {
      payload.product_handle = identifier(attribute(target, area, 'product-handle') || config.productHandle);
      if (!payload.product_handle) return null;
    }

    var urlNote = {};
    if (target.tagName === 'A') {
      var url = hrefForAction(target);
      if (!url) return null;
      var path = safeTargetPath(url, urlNote);
      if (path) payload.target_url = path;
    }
    return { params: payload, omittedUrlReason: urlNote.reason };
  }

  function collectClick(event, earlyLoadMoreEligible, originalClickedAt) {
    if (!active || event.isTrusted !== true || (typeof event.button === 'number' && event.button !== 0)
        || seen.has(event)) return;
    var origin = event.target;
    if (origin && origin.nodeType !== 1) origin = origin.parentElement;
    if (!origin || typeof origin.closest !== 'function') return;
    var target = origin.closest('[data-bh-area][data-bh-entry-type]');
    if (!target) return;
    seen.add(event);
    state.matched += 1;
    var area = target.getAttribute('data-bh-area');
    var entry = target.getAttribute('data-bh-entry-type');
    var type = pageType(config.pageType);
    if (!kinds[area] || kinds[area].indexOf(entry) === -1 || !config.areas || config.areas[area] !== true
        || !type || !inScope(area, type)) return record('rejected', 'outside_scope');
    if (disabled(target)) return record('rejected', 'disabled');

    if (area === 'load_more') {
      var pagination = target.closest('custom-pagination');
      if (target.tagName !== 'BUTTON' || !target.classList.contains('btn--load-more') || !pagination
          || pagination.getAttribute('data-type') !== 'load-more-button') return record('rejected', 'not_load_more_button');
      // Only the bridge's original allowed click can predate the theme's
      // synchronous loading flag. All other validation remains current.
      if (!earlyLoadMoreEligible && (pagination.hasAttribute('loading') || target.classList.contains('loading'))) return record('rejected', 'loading');
      // The theme hides exhausted pagination without disabling its still-focusable button.
      if (target.classList.contains('visually-hidden') || target.classList.contains('visibility-hidden')) return record('rejected', 'hidden_load_more');
    } else if (area === 'description') {
      if (target.tagName !== 'SUMMARY' || !target.closest('collapsible-details')) return record('rejected', 'not_description_header');
    } else if (target.tagName !== 'A') {
      return record('rejected', 'not_navigation_link');
    }

    var built = makePayload(target, area, entry, type);
    if (!built) return record('rejected', 'invalid_parameters');
    var payload = built.params;
    if (typeof window.emitBhClick !== 'function') return record('rejected', 'sender_missing', payload, built.omittedUrlReason);
    try {
      var sameTab = target.tagName === 'A' && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey &&
        event.defaultPrevented !== true && !target.hasAttribute('download') &&
        (!target.getAttribute('target') || target.getAttribute('target').toLowerCase() === '_self');
      var result = window.emitBhClick(payload, { sameTab: sameTab, event: event, element: target,
        createdAt: Number.isFinite(originalClickedAt) ? originalClickedAt : Date.now() });
      if (result === false) record('rejected', 'sender_declined', payload, built.omittedUrlReason);
      else record('submitted', 'adapter_accepted', payload, built.omittedUrlReason);
    } catch (ignore) {
      record('error', 'sender_error', payload, built.omittedUrlReason);
    }
    // No preventDefault, stopPropagation, callback wait, timer or navigation mutation.
  }

  function onClick(event, earlyLoadMoreEligible, originalClickedAt) {
    var measure = diagnosticsEnabled() && window.performance && typeof window.performance.now === 'function';
    var startedAt = measure ? window.performance.now() : 0;
    var before = state.matched;
    try { collectClick(event, earlyLoadMoreEligible === true, originalClickedAt); }
    catch (ignore) {
      // An unexpected collector/diagnostic failure must never escape into the storefront.
      try { record('error', 'collector_error'); } catch (diagnosticError) { /* keep navigation intact */ }
    }
    if (measure && state.matched > before) {
      state.handlerSamplesMs.push(Math.max(0, window.performance.now() - startedAt));
      if (state.handlerSamplesMs.length > 200) state.handlerSamplesMs.shift();
    }
  }

  function readConfig() {
    var el = document.getElementById('bh-tracking-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (ignore) { return null; }
  }

  var api = {
    version: VERSION,
    init: function (options) {
      if (active) return true;
      config = options || readConfig();
      var bridge = window.__bhEarlyClickBridge;
      if (!config || config.enabled !== true || !pageType(config.pageType)) {
        if (bridge && bridge.document === document && typeof bridge.cancel === 'function') {
          try { bridge.cancel(); } catch (ignore) { /* keep normal page behavior */ }
        }
        return false;
      }
      var earlyRecords = [];
      // Claim removes the early listener before this one is installed. Native
      // dispatch cannot interleave this synchronous handoff; the original event
      // objects retain the normal WeakSet duplicate guard and full validation.
      if (bridge && bridge.version === '1.0.1-candidate' && bridge.document === document && typeof bridge.takeover === 'function' &&
          typeof bridge.validateRecord === 'function' && typeof bridge.eligibleLoadMore === 'function' &&
          typeof bridge.releaseRecord === 'function' && typeof bridge.complete === 'function') {
        try { earlyRecords = bridge.takeover(); } catch (ignore) { earlyRecords = []; }
      }
      active = true;
      document.addEventListener('click', onClick, true);
      try {
        earlyRecords.forEach(function (record) {
          try {
            if (bridge.validateRecord(record)) onClick(record.event, bridge.eligibleLoadMore(record), record.at);
          } finally { bridge.releaseRecord(record); }
        });
      } finally {
        if (bridge && bridge.document === document && typeof bridge.complete === 'function') bridge.complete();
      }
      renderDiagnostics();
      return true;
    },
    destroy: function () {
      document.removeEventListener('click', onClick, true);
      active = false;
      seen = new WeakSet();
      var el = document.getElementById('bh-tracking-diagnostics');
      if (el) el.remove();
    },
    diagnostics: function () {
      return JSON.parse(JSON.stringify({ version: VERSION, active: active, collector: state }));
    },
    resetDiagnostics: function () { state = freshState(); renderDiagnostics(); }
  };
  window.BHClickTracker = api;
  api.init();
})(window, document);
